module.exports = {"id":"172175","name":"Kevin Mirallas","rating":"79","photo":"./data/images/photos/1/172175.png","club":{"name":"Olympiakos CFP","logo":"./data/images/clubs/OlympiakosCFP.png"},"positions":["MG","AG","BU"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KevinMirallas0.json
// module id = 2348
// module chunks = 0